module.exports = __webpack_public_path__ + "img/odometer.383df1de.svg";